export default "__VITE_ASSET__457145f8__"